import { ColorProps, IconButton, IconButtonProps } from '@chakra-ui/react';
import { FC, useState } from 'react';

import { AvailableIcons, Icon } from '$/components/common/Icon';

interface LoadingIconButtonProps
  extends Omit<IconButtonProps, 'onClick' | 'icon'> {
  onClick: () => Promise<void>;
  icon: AvailableIcons;
  iconColor: ColorProps['color'];
}

type ButtonState = 'idle' | 'loading' | 'success';

export const RespondingIconButton: FC<LoadingIconButtonProps> = ({
  onClick,
  icon,
  iconColor = 'reverseText',
  ...props
}) => {
  const [buttonState, setButtonState] = useState<ButtonState>('idle');

  const handleClick = async () => {
    setButtonState('loading');
    await onClick();
    setButtonState('success');
    setTimeout(() => {
      setButtonState('idle');
    }, 1000);
  };

  const bg = buttonState === 'success' ? 'success.900' : undefined;

  return (
    <IconButton
      {...props}
      bg={bg}
      _hover={{ bg }}
      aria-label='icon button'
      icon={
        buttonState === 'success' ? (
          <Icon
            icon='check_icon'
            color={buttonState === 'success' ? 'text' : 'reverseText'}
          />
        ) : (
          <Icon icon={icon} color={iconColor} />
        )
      }
      isLoading={buttonState === 'loading'}
      onClick={handleClick}
      variant='primary'
    />
  );
};
